import { INews, INewsListItem, NewsResponseType } from "./news.types";

export default class News implements  INews {
    total: number;
    data: INewsListItem[] = [];
    constructor(data: NewsResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}